import { wishStore } from "#sitis/stores/modules/wish-store";
import { storeToRefs } from "pinia";
export default function useSitisWish() {
  const wishListStore = wishStore();
  const {
    wishList,
    wishlistCount,
    loadingList,
    isInWishlist
  } = storeToRefs(wishListStore);
  const getWishList = async (params) => await wishListStore.getWishList(params);
  const isInWish = (id) => isInWishlist.value(id);
  const addToWishList = async ({ id }) => await wishListStore.addToWishList({ id });
  const removeItemFromWishList = async (id) => await wishListStore.removeItemFromWishList(id);
  const clearWishList = async () => await wishListStore.clearWishList();
  return {
    wishList,
    wishlistCount,
    loadingList,
    isInWish,
    getWishList,
    addToWishList,
    removeItemFromWishList,
    clearWishList
  };
}
